class AnimationPaginationSuccessCasesGrid {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleAnimationPaginationSuccessCases = this.sectionsContainer.querySelectorAll('.pagination-success-cases .wrapper-rest-cases');
		
		if (!this.$moduleAnimationPaginationSuccessCases.length) { //console.log('no encuentro seccion');
		    return;
		} /*else {
		    console.log(this.$moduleAnimationPaginationSuccessCases)
		}*/
		
		this.$moduleAnimationPaginationSuccessCasesElements = [];
		this.$moduleAnimationPaginationSuccessCases.forEach(module => {
			this.$moduleAnimationPaginationSuccessCasesElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleAnimationPaginationSuccessCases.forEach((module, index) => {
		    console.log(this.$moduleAnimationPaginationSuccessCasesElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleAnimationPaginationSuccessCasesElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleAnimationPaginationSuccessCases = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleAnimationPaginationSuccessCases[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleAnimationPaginationSuccessCasesElements[index], { clearProps: true });
			}
        });

        moduleAnimationPaginationSuccessCases.addLabel('step1');
        moduleAnimationPaginationSuccessCases.to(this.$moduleAnimationPaginationSuccessCases[index], { opacity: 1, duration: 1 }, 'step1');
		moduleAnimationPaginationSuccessCases.to(this.$moduleAnimationPaginationSuccessCasesElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationPaginationSuccessCasesGrid;
